async function getOtica(conta, session_token){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + session_token,
    },
    body: JSON.stringify({ cnpj: conta }),
  };

  return fetch(process.env.REACT_APP_LABS_API + "get_optics.php", requestOptions)
    .then(response => response.json())
    .then(json => {
      if (json.status === "sucesso") {
        return json.items;
      }
      return null;
    })
    .catch(error => {
      console.error("Erro ao buscar ótica:", error);
      return null;
    });
}

export { getOtica };
